import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { BANNER_VARIANT_ICONS } from 'ui/banner';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { BannerVariants } from 'ui/banner/types';

import { ApiMethod } from 'services/api';
import { UNARCHIVE_CAMPAIGN_URL } from 'api/CampaignIndexAPI';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';

import { CampaignStateDefinition } from '../BaseSendEditor.constants';
import { useCampaign } from '../BaseSendEditor.hooks';
import { SendBanner } from '../SendBanner';

export const UNARCHIVE_BANNER_TEST_ID = 'unarchive-banner';

export const UnarchiveBanner = ({ campaignId }: { campaignId?: number }) => {
  const dispatch = useDispatch();
  const { updateCampaign } = useCampaign();
  const { mutate, isLoading } = useRestMutation(UNARCHIVE_CAMPAIGN_URL, ApiMethod.post);

  const unarchiveCampaign = useCallback(() => {
    mutate(
      { campaignIds: [campaignId] },
      {
        onSuccess: () => {
          dispatch(addPositiveToast('This campaign has been unarchived.'));
          updateCampaign({ campaignState: CampaignStateDefinition.Ready });
        },
        onError: () => {
          dispatch(addNegativeToast('Unable to unarchive campaign.'));
        },
      },
    );
  }, [campaignId]);

  return (
    <SendBanner
      title="This campaign has been archived"
      Icon={BANNER_VARIANT_ICONS[BannerVariants.WARNING]}
      data-test={UNARCHIVE_BANNER_TEST_ID}
      BannerActions={
        <Button
          onClick={unarchiveCampaign}
          size={BUTTON_SIZES.SMALL}
          variant={BUTTON_VARIANTS.SECONDARY}
          isDisabled={isLoading}
        >
          Unarchive
        </Button>
      }
    >
      Users who go through this tile won’t receive a message. Unarchive the campaign to re-enable
      sending.
    </SendBanner>
  );
};
